export default {
  owned: '拥有',

  gem_prestigeStone: {
    name: '声望石',
    description: '获得与您的最佳周期相等的声望货币'
  },
  mining_goldenHammer: {
    name: '金锤',
    description: '为这门手艺找到最好的镐'
  },
  village_ingredientBox: {
    name: '配料箱',
    description: '含有只有在这些盒子里才能找到的特殊成分'
  },
  horde_manaPotion: {
    name: '法力药水',
    description: '补充50%的最大法力值'
  },
  farm_basic: {
    name: '基础肥料',
    description: ''
  },
  farm_flower: {
    name: '花肥',
    description: ''
  },
  farm_speedGrow: {
    name: '快速生长',
    description: ''
  },
  farm_richSoil: {
    name: '肥沃的土壤',
    description: ''
  },
  farm_shiny: {
    name: '闪亮肥料',
    description: ''
  },
  farm_juicy: {
    name: '多汁肥料',
    description: ''
  },
  farm_dissolving: {
    name: '作物溶解剂',
    description: ''
  },
  farm_potatoWater: {
    name: '土豆水',
    description: ''
  },
  farm_roseWater: {
    name: '玫瑰水',
    description: ''
  },
  farm_weedKiller: {
    name: '除草剂',
    description: ''
  },
  farm_turboGrow: {
    name: '涡轮生长',
    description: ''
  },
  farm_premium: {
    name: '优质肥料',
    description: ''
  },
  farm_analyzing: {
    name: '分析肥料',
    description: ''
  },
  farm_superJuicy: {
    name: '超级多汁',
    description: ''
  },
  farm_pellets: {
    name: '颗粒',
    description: ''
  },
  farm_sunshine: {
    name: '阳光',
    description: ''
  },
  farm_superFlower: {
    name: '超级鲜花',
    description: ''
  },
  farm_smellyMud: {
    name: '臭泥',
    description: ''
  },
  farm_tropicalWater: {
    name: '热带水',
    description: ''
  },
  farm_fieldBlessing: {
    name: '田野祝福',
    description: ''
  },
  farm_cinnamonBag: {
    name: '肉桂袋',
    description: ''
  },
};
